import React, { ReactElement, PropsWithoutRef, useEffect, useState } from 'react';
import { getBreakpoint, translate } from '@micro-apps/env';
import './FilterCategories.scss';

import Carousel from '../Carousel/Carousel';
import classNames from 'classnames';
export type Category = {
	value: string;
	total: number;
};
type Props = {
	categories: Category[];
	onChange?: (category: Category) => void;
};
export default function FilterCategories({
	categories = [],
	onChange,
}: PropsWithoutRef<Props>): ReactElement {
	const [total, setTotal] = useState(0);
	const [selected, setSelected] = useState(-1);
	const isDesktop = getBreakpoint().includes('large');
	useEffect(() => {
		setTotal(
			categories.reduce((acc, category) => {
				return acc + category.total;
			}, 0)
		);
	}, [categories]);

	useEffect(() => {
		if (onChange) {
			onChange(categories[selected] ?? { value: 'all', total });
		}
		if (!isDesktop) {
			document
				.querySelector('.FilterCategories-mobile .FilterCategories-filter--active')
				?.scrollIntoView({
					behavior: 'smooth',
					block: 'nearest',
					inline: 'center',
				});
		}
	}, [categories, isDesktop, onChange, selected, total]);

	return (
		<div className="FilterCategories">
			<div className="FilterCategories-mobile FilterCategories-wrapper">
				<Carousel
					id="FilterCategories"
					showDots={false}
					elements={[
						<button
							key={`viewall-mobile`}
							className={classNames('FilterCategories-filter ty-c2', {
								'FilterCategories-filter--active': selected === -1,
							})}
							onClick={() => setSelected(-1)}
						>
							{translate('View All')} ({total})
						</button>,
						...categories.map((category, i) => (
							<button
								key={`${i}-mobile`}
								className={classNames('FilterCategories-filter ty-c2', {
									'FilterCategories-filter--active': selected === i,
								})}
								data-filter-tag="guest_rooms"
								onClick={() => setSelected(i)}
							>
								{category.value} ({category.total})
							</button>
						)),
					]}
				></Carousel>
			</div>
			<div className="FilterCategories-desktop FilterCategories-wrapper">
				<button
					className={classNames('FilterCategories-filter ty-c2', {
						'FilterCategories-filter--active': selected === -1,
					})}
					onClick={() => setSelected(-1)}
				>
					{translate('View All')} ({total})
				</button>
				<div className="FilterCategories-border"></div>
				{categories.map((category, i) => (
					<button
						key={`${i}-desktop`}
						className={classNames('FilterCategories-filter ty-c2', {
							'FilterCategories-filter--active': selected === i,
						})}
						data-filter-tag="guest_rooms"
						onClick={() => setSelected(i)}
					>
						{category.value} ({category.total})
					</button>
				))}
			</div>
		</div>
	);
}
